import { asyncRouterMap, constantRouterMap } from '@/router/config';
import { defineStore } from 'pinia';
/**
 * 过滤账户是否拥有某一个权限，并将菜单从加载列表移除
 *
 * @param permission 权限设定值
 * @param route      路由
 * @returns {boolean}
 */
function hasPermissionCate (permission, route) {
  if (route.meta && route.meta.permission) {
    let flag = false;
    for (let i = 0, len = permission.length; i < len; i++) {
      flag = route.meta.permission.includes(permission[i]);
      if (flag) {
        return true;
      }
    }
    return false;
  }
  return true;
}

/**
 * 根据权限表格式化生成可访问路由菜单
 * 
 * @param {*} routerMap 预设路由
 * @param {*} roles     用户权限设置表
 */
function filterAsyncRouter (routerMap, roles) {
  // 循环过滤不符合值
  const accessedRouters = routerMap.filter(route => {
    if (hasPermissionCate(roles, route)) {
      if (route.children && route.children.length) {
        // 递归执行
        route.children = filterAsyncRouter(route.children, roles);
      }
      return true;
    }
    return false;
  });
  // 返回最终过滤值
  return accessedRouters;
}

// // 过滤无权限路由
// function hasPermission (rules, route) {
//   if (route.meta && route.meta.permissionId) {
//     return rules.includes(route.meta.permissionId);
//   }
//   return true;
// }
// function filterPermissionRouter (routerMap, rules) {
//   // 循环过滤不符合值
//   const accessedRouters = routerMap.filter(route => {
//     if (hasPermission(rules, route)) {
//       if (route.children && route.children.length) {
//         // 递归执行
//         route.children = filterPermissionRouter(route.children, rules);
//       }
//     } else {
//       route.hidden = true;
//     }
//     return true;
//   });
//   // 返回最终过滤值
//   return accessedRouters;
// }

// function findFirstPermissionRouter(routes, rules) {
//   for (let i = 0; i < routes.length; i++) {
//     const item = routes[i];
//     if (item.meta && rules.includes(item.meta.permissionId) && item.path !== '/' && !item.redirect) {
//       return item;
//     }
//     if (item.children) {
//       let route = findFirstPermissionRouter(item.children, rules);
//       if (route) {
//         return route;
//       }
//     }
//   }
// }


export const permissionStore = defineStore('permission', {
  state: () => {
    return {
      routers: constantRouterMap,
      indexRouter: null,
      addRouters: []
    };
  },
  
  actions: {
    GenerateRoutes () {
      return new Promise(resolve => {
        
        const accessedRouters = filterAsyncRouter(asyncRouterMap);

        this.addRouters = accessedRouters;
        this.routers = constantRouterMap.concat(accessedRouters);
        
        this.indexRouter = accessedRouters[0];

        resolve();
      });
    }
  }
});